/*
SPDX-FileCopyrightText: 2022 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { httpClient } from '../http/httpClient';
import { tokenHasExpired } from '../localStorage/localStorageService';
export function getUrlLogin() {
    return httpClient().get('/auth/login');
}
export function getToken(dataPost) {
    return httpClient().post('/auth/token', dataPost);
}
export function getProfile(token) {
    return httpClient().post('/auth/profile', { token: token });
}
export function getRoles() {
    return httpClient().get('/auth/roles');
}
export function confirmAuthorised(user, auth) {
    if (typeof auth === 'boolean') {
        return auth && user && !tokenHasExpired();
    }
    if (auth) {
        if (user && !tokenHasExpired()) {
            for (var _i = 0, auth_1 = auth; _i < auth_1.length; _i++) {
                var role = auth_1[_i];
                if (user.roles.includes(role)) {
                    return true;
                }
            }
        }
        return false;
    }
    return true; // no auth required
}
